module.exports = __webpack_public_path__ + "static/1.2_1440x540_Desktop_Hero_1X-1b190e7a368ab6c60ca582b9823b1ca7.png";